import React from 'react';
import styled from 'styled-components';

import TextComponent from '@/components/TextComponent';
import { ReactComponent as Close } from '@/assets/images/common/close.svg';
import theme from '@/styles/theme';

interface Props {
  modalTitle?: string;
  onClose: () => void;
  children?: React.ReactNode;
}

function BaseModal(props: Props) {
  const { modalTitle, onClose, children } = props;

  return (
    <ModalOverlay
      ref={ref => ref?.focus()}
      id="keyboard"
      tabIndex={0}
      onClick={onClose}>
      <ModalWrapper>
        <ModalHeader>
          <ModalTitle>{modalTitle}</ModalTitle>
          <Close
            stroke={theme.DF_COLOR.GRAY600}
            strokeWidth={2.5}
            style={{ width: '27px', height: '27px' }}
            onClick={() => onClose()}
          />
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
      </ModalWrapper>
    </ModalOverlay>
  );
}

const ModalOverlay = styled.div`
  box-sizing: border-box;
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 815;
`;

const ModalWrapper = styled.div`
  background-color: ${theme.DF_COLOR.WHITE};
  padding: 1.5rem;
  min-width: 50%;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2rem;
`;

const ModalTitle = styled(TextComponent)`
  color: #676777;
  font-size: 20px;
  font-weight: 600;
`;

const ModalBody = styled.div``;

export default BaseModal;
